import {
  toWSDateString,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { ApiKey } from "@wingspanhq/wingspan-api-sdk";

export const getColumns = (): WSTableColumn<ApiKey>[] => [
  {
    config: { gridTemplateSizeMax: "1fr", header: { text: "Name" } },
    renderFunction: rowItem => (
      <WSTableCell
        text={rowItem.data.name}
        secondaryText={
          rowItem.data.lastUsedAt
            ? `Last used ${toWSDateString(rowItem.data.lastUsedAt, "timeframe")}`
            : "Never used"
        }
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "0.5fr",
      hideOnScreens: ["XS", "S"],
      justify: "end",
      header: { text: "Scopes" }
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={
          rowItem.data.scopes.length
            ? `${rowItem.data.scopes.length} scopes`
            : "No scopes"
        }
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "0.5fr",
      justify: "end",
      header: { text: "Expires" }
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={
          rowItem.data.expiresAt
            ? toWSDateString(rowItem.data.expiresAt, "monthDayYear")
            : "No expiry"
        }
      />
    )
  }
];
